module.exports = __webpack_public_path__ + "static/media/rounded-green-check.7636c982.svg";